import { UseCase } from '../../base';
import { CreateEditPrivateLocationRequest } from '../../domain/requests';
import { LocationsRepository } from '../../repositories';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class CreateEditPublicLocationUsecase
  implements UseCase<CreateEditPrivateLocationRequest, CreateEditPrivateLocationRequest>
{
  constructor(private locationRepository: LocationsRepository) {}

  execute(params: CreateEditPrivateLocationRequest): Observable<CreateEditPrivateLocationRequest> {
    return this.locationRepository.createEditPublicLocation(params);
  }
}
